<template>
  <div class="container">
        <div class="position" style="margin-right:1rem">
            <p class="titleName">通信协议软件工程师</p>
            <p class="tipName">工作职责：</p>
            <p class="requirement">LTE/5G移动通信协议软件开发、维护和测试</p>
            <p class="requirement">面向客户需求分析和技术支持</p>
            <p class="tipName">任职资格：</p>
            <p class="requirement">1. 熟悉3GPP 相关移动通信协议，协议软件研发工作经验不少于2年；</p>
            <p class="requirement">2. 精通3GPP L2/L3/NAS 层相关空口协议；</p>
            <p class="requirement">3. 熟悉 AT command、Linux/Windows驱动更佳；</p>
            <p class="requirement">4. 有丰富的 C/C++编程经验；</p>
            <p class="requirement">5. 通信，电子相关专业，硕士及以上学历；</p>
            <p class="requirement">6. 英语文档阅读能力优秀。</p>
        </div>
        <div class="position" style="margin-left:1rem">
            <p class="titleName">技术支持工程师</p>
            <p class="tipName">工作职责：</p>
            <p class="requirement">支持客户项目工作。</p>
            <p class="requirement">调查、分析、定位测试中发现的问题。</p>
            <p class="requirement">与研发同事充分沟通客户需求，解决问题。</p>
            <p class="requirement">协助客户搭建测试设备，组建测试环境。</p>
            <p class="requirement">调试测试脚本。</p>
            <p class="tipName">任职资格：</p>
            <p class="requirement">1. 一年以上通信测试工作经验；</p>
            <p class="requirement">2. 计算机或通信专业；</p>
            <p class="requirement">3. 熟悉3GPP协议；</p>
            <p class="requirement">4. 熟悉Linux操作；</p>
            <p class="requirement">5. 良好的技术沟通能力；</p>
            <p class="requirement">6. 能与客户用英文交流；</p>
            <p class="requirement">6. 快速学习的能力；</p>
        </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      positions: [{name:'通信协议软件工程师'}]
    }
  }
}
</script>

<style scoped>
.container{
  width: 100%;
  height: 100%;
  /* position: relative; */
  display:flex;
  justify-content: center;
  align-items:center;
}
.position{
  width: 20rem;
  height: 25rem;
  background-color: rgba(0,0,0,0.1);
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding: 0 1.5rem;
  /* position: absolute; */
  /* left: 50%; */
  /* margin-left: -10rem; */
}
.titleName{
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: gray;
}
.tipName{
  /* text-indent: 1rem; */
  font-weight: bold;
  font-size: 1rem;
  line-height: 2rem;
}
.requirement{
  font-size: 0.9rem;
  /* text-indent: 1rem; */
}
</style>



// WEBPACK FOOTER //
// src/components/recruit.vue